import React from "react";

import { HStack, Stack, Text } from "@/components/ui";

import { generateText } from "../utils";

import PlaceholderAvatar from "./placeholder-avatar";
import PlaceholderMutualFollowers from "./placeholder-mutual-followers";
import PlaceholderTabs from "./placeholder-tabs";

/** Fake profile to display while data is loading. */
const PlaceholderProfile = () => (
  <>
    <div className="relative h-32 w-full animate-pulse bg-placeholder lg:h-48" />

    <div className="px-4 sm:px-6">
      <PlaceholderAvatar
        size={96}
        className="-mt-9 size-24 rounded-full ring-4 ring-white dark:ring-gray-900"
      />
    </div>

    <Stack space={2} className="mt-3 mb-6 animate-pulse px-4 text-placeholder">
      <Stack>
        <Text size="lg" theme="placeholder">
          {generateText(10)}
        </Text>
        <Text theme="placeholder">{generateText(10)}</Text>
      </Stack>

      <Text theme="placeholder">{generateText(30)}</Text>

      <HStack alignItems="center" space={1}>
        <Text theme="placeholder">{generateText(12)}</Text>
        <Text theme="placeholder">{generateText(4)}</Text>
        <Text theme="placeholder">{generateText(6)}</Text>
      </HStack>

      <PlaceholderMutualFollowers />
    </Stack>

    <PlaceholderTabs count={3} />
  </>
);

export default React.memo(PlaceholderProfile);
